import { Injectable } from "@angular/core";

import { json } from "@codemirror/lang-json";
import { LanguageDescription, LanguageSupport } from "@codemirror/language";


@Injectable()
export class JsonEditorLanguageService {

    public getLanguageDescription(): LanguageDescription {
        const language: LanguageSupport = json();

        return LanguageDescription.of({ name: language.language.name, support: language })
    }
}